/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Wed Oct 25 2023
 **/

import { useState } from "react";

import { SwitchCase } from "@/frameworks/libraries/components";

import AccountSetting from "./AccountSetting";
import DeleteAccount from "./DeleteAccount";

export default function Account() {
	const [page, setPage] = useState<"delete" | "setting">("setting");
	return (
		<SwitchCase
			condition={page}
			cases={{
				setting: <AccountSetting move={setPage} />,
				delete: <DeleteAccount move={setPage} />
			}}
		/>
	);
}
